import { format } from "date-fns";
import { FlightCore } from "types";


export namespace FlightsUseCases {
  
  export const composeSearchID = ({
    fromId,
    toId,
    tripType,
    departDate,
    returnDate
  }: {
    fromId: string,
    toId: string,
    tripType: FlightCore.TripType,
    departDate: Date,
    returnDate?: Date
  }) => {
    const formatDate = (date: Date) => format(date, 'DDMM');
    const returnDateFormatted = (tripType === FlightCore.TripType.RoundTrip && returnDate) ? formatDate(returnDate) : '';
    return String(fromId + formatDate(departDate) + toId + returnDateFormatted);
  }
  
}

export * from './reducer';
export * from './excludeAgents';